import { render, staticRenderFns } from "./zhishu.vue?vue&type=template&id=d403b908"
import script from "./zhishu.vue?vue&type=script&lang=js"
export * from "./zhishu.vue?vue&type=script&lang=js"
import style0 from "./zhishu.vue?vue&type=style&index=0&id=d403b908&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports